
const digest = '93a1a58d329cbe7d17cfee45f26f9cce1ab168870f2d7e550d314b3fe2c36e8e';
const classes = {"wrapper":"_wrapper_1jc9n_1","unseen":"_unseen_1jc9n_7","date":"_date_1jc9n_20","title":"_title_1jc9n_25","text":"_text_1jc9n_31"};
const css = `._wrapper_1jc9n_1 {
  padding: 20px;
  background-color: #fff;
  position: relative;
  border-bottom: 1px solid #ddd;
}
._wrapper_1jc9n_1._unseen_1jc9n_7 {
  background-color: #fff;
}
._wrapper_1jc9n_1._unseen_1jc9n_7:before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background-color: #619612;
  position: absolute;
  right: 20px;
  top: 20px;
}
._wrapper_1jc9n_1 ._date_1jc9n_20 {
  color: #000;
  font-size: 12px;
  margin-bottom: 3px;
}
._wrapper_1jc9n_1 ._title_1jc9n_25 {
  color: #1d65d8;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 3px;
}
._wrapper_1jc9n_1 ._text_1jc9n_31 {
  color: #000;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  